exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,700,800,900&display=swap);", ""]);

// module
exports.push([module.id, ".Partner-Module__partner___2BOgq{height:62px;width:62px;justify-self:center;transition:all .2s ease-in-out;background-size:contain;background-repeat:no-repeat;background-position:50%}.Partner-Module__partner___2BOgq:hover{transform:scale(1.2)}@media only screen and (max-width:1100px){.Partner-Module__partner___2BOgq:hover{transform:scale(1.1)}}", ""]);

// exports
exports.locals = {
	"partner": "Partner-Module__partner___2BOgq"
};